module.exports = __webpack_public_path__ + "static/media/contractIncoming.2e1f8dc3.svg";